export default __webpack_public_path__ + "static/media/top_left.763983ac.svg";